var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBbTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5882 14.0501L13.2324 20.4392C12.8388 20.6814 12.6571 21.1659 12.7782 21.6201L13.8986 25.5565C13.9894 25.8291 14.3831 25.7988 14.4133 25.5263L14.7161 23.3764C14.7767 22.9827 14.9584 22.5891 15.2612 22.3166L23.8304 14.3529C23.9818 14.2015 23.8002 13.9593 23.5882 14.0501Z",
    fill: "#FDDF33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9849 0C8.96291 0 0 8.9629 0 19.9849C0 31.0371 8.96291 39.9697 19.9849 39.9697C31.0371 39.9697 39.9697 31.0068 39.9697 19.9849C40 8.9629 31.0371 0 19.9849 0ZM28.7964 10.6586L24.8902 29.4625C24.7994 29.9167 24.2846 30.0984 23.9213 29.8259L18.592 25.95C18.2589 25.7078 17.835 25.7381 17.5019 25.9803L14.5344 28.4027C14.2014 28.6752 13.6866 28.5238 13.5352 28.0999L11.5064 21.4989L6.20742 19.5307C5.66238 19.3187 5.66238 18.5617 6.20742 18.3497L27.9788 9.96215C28.433 9.78047 28.9175 10.1741 28.7964 10.6586Z",
    fill: "#FDDF33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbTelegramIcon);
export default __webpack_public_path__ + "static/media/BB-telegram-icon.92783023333ebf7c891e803e6011d0d5.svg";
export { ForwardRef as ReactComponent };